module.exports = __webpack_public_path__ + "img/special.8d01b9ed.jpg";